import { render, staticRenderFns } from "./AppSettingsMenu.vue?vue&type=template&id=063bfcee&scoped=true&"
import script from "./AppSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./AppSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsMenu.vue?vue&type=style&index=0&id=063bfcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bfcee",
  null
  
)

export default component.exports